<script setup lang="ts">
import { $ti } from '@/locize';
import { Race, type StationRole } from '@/objects/generated';

const props = defineProps<{
    stationroles: Array<StationRole> | null | undefined;
    raceId?: number | null;
    races?: Array<Race> | null;
}>();

const getRaceCaption = (raceId: number | Race | null) => {
    if (raceId == null) {
        return null;
    }

    let race: Race | null = null;
    // Check if raceId is of type number or string
    if (raceId instanceof Race) {
        race = raceId;
    } else {
        race = props.races?.find((x) => x.ID == raceId) ?? null;
    }

    if (!race || !race.Name) {
        return null;
    }

    // If the text is 5 or less long we return all, or else we return the first 5 characters
    return (race.Name?.substring(0, 10) ?? '') + (race.Name!.length > 10 ? '...' : '');
};
</script>
<template>
    <template
        v-if="props.stationroles"
        v-for="(sr, i) in props.stationroles"
        :key="i"
    >
        <template v-if="!raceId || sr.RaceID == raceId">
            <br v-if="i > 0 && props.stationroles[i - 1].RaceID != sr.RaceID" />
            <span
                v-if="i == 0 || props.stationroles[i - 1].RaceID != sr.RaceID"
                class="badge bg-light text-dark text-start cursor-help border"
                style="width: 66px !important"
                :title="races?.find((x) => x.ID == sr.RaceID)?.Name ?? ''"
                >{{ getRaceCaption(sr.RaceID) }}</span
            >
            <span
                class="badge me-1 cursor-help"
                :class="{
                    'opacity-50': !sr.Public,
                    'bg-dark text-light': !sr.Finish,
                    'bg-info-subtle': sr.Finish,
                }"
                :title="
                    $ti('dashboard.stationtitle', {
                        name: sr.Name,
                        km: sr.Km,
                        public: sr.Public ? $tm('general.yes') : $tm('general.no'),
                        finish: sr.Finish ? $tm('general.yes') : $tm('general.no'),
                    })
                "
                >{{ sr.Name }}</span
            >
        </template>
    </template>
</template>
